import { cn } from '@/utils/cn';
import { View } from 'react-native';
import { Avatar, AvatarFallback, AvatarImage } from './nativewind-ui/avatar';
import { Text } from './ui/text';

export function PersonaAvatar({
  persona,
  className
}: {
  persona: {
    id: string;
    avatarUrl?: string | null;
    name: string;
  };
  className?: string;
}) {
  return (
    <Avatar alt="avatar" className={cn('h-12 w-12', className)}>
      {persona.avatarUrl && <AvatarImage source={{ uri: persona.avatarUrl }} />}
      <AvatarFallback className="z-50 border border-[#1d312e]">
        <View className="opacity-90 dark:opacity-80">
          <Text className="dark:ios:text-white leading-6 text-white dark:text-background">
            {persona.name
              .split(' ')
              .map((name) => name.charAt(0).toUpperCase())
              .slice(0, 2)
              .join('') || 'AA'}
          </Text>
        </View>
      </AvatarFallback>
    </Avatar>
  );
}
